import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import GeoBanner from "@/components/GeoBanner";
import { Toaster } from "@/components/ui/sonner";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return (
    <div className="flex min-h-screen flex-col bg-bg" data-testid="layout-root">
      <Header />
      <main className="flex-1" data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
      <GeoBanner />
      <Toaster richColors position="top-right" />
    </div>
  );
}
